import { Fragment, useState } from 'react';
import { Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { createPrescriptionTemplate } from '../../../../../store/actions/prescriptionPad';
import CreateTemplateComp from '../../finishScreen/CreateTemplateDialog';
import { Kind } from '../../../../../store/types/prescription';
import PxToolKeyOptions from './PxToolKeyOptions';
import { ALL_KINDS } from '../../../../../utils/enums';

const PackageIcons: React.FC<{
    pxToolKey: keyof Kind;
    save?: boolean;
    isV2?: boolean;
    isModal: boolean;
    withPeak: boolean;
    isCancelActive?: boolean;
}> = ({ pxToolKey, save = true, isV2 = true, isModal, withPeak, isCancelActive = true }) => {
    const [saveAsPackageVisible, setSaveAsPackageVisible] = useState(false);
    const prescriptionPadSelectorFunc = PxToolKeyOptions[pxToolKey].selectorFunc;
    const prescriptionPadStateData = useSelector(prescriptionPadSelectorFunc);
    const dispatch = useDispatch();

    const onSavePackage = (name: string, id?: string) => {
        dispatch(createPrescriptionTemplate(pxToolKey, name, id, undefined, true));
        setSaveAsPackageVisible(false);
        return;
    };

    return (
        <Fragment>
            <div className="flex items-center space-x-16">
                {save &&
                    (prescriptionPadStateData.length === 0 ? (
                        <div
                            className={`flex items-center justify-center w-24 h-24 ${
                                isV2 ? 'bg-neutral-9' : 'bg-white'
                            } rounded-full min-w-24 min-h-24 cursor-pointer`}
                        >
                            <Tooltip
                                placement="left"
                                overlayInnerStyle={{
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '4px 8px',
                                    backgroundColor: 'rgba(57, 68, 82, 1)',
                                    color: 'white',
                                }}
                                title={
                                    <span className="font-lato font-700 text-white">
                                        Select Some {PxToolKeyOptions[pxToolKey].tooltipText} to
                                        Save as Package
                                    </span>
                                }
                            >
                                <p className="font-700 text-neutral-3">P</p>
                            </Tooltip>
                        </div>
                    ) : (
                        <div className="relative">
                            <div
                                onClick={() => setSaveAsPackageVisible(true)}
                                className={`relative flex items-center justify-center w-24 h-24 ${
                                    isV2 ? 'bg-neutral-9' : 'bg-white'
                                } rounded-full min-w-24 min-h-24 cursor-pointer`}
                            >
                                <p className="font-700 text-neutral-3">P</p>
                            </div>
                            {saveAsPackageVisible && (
                                <CreateTemplateComp
                                    key="create-package"
                                    // TODO add proper tyoes
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    kind={ALL_KINDS[PxToolKeyOptions[pxToolKey].kind]}
                                    onCancel={() => setSaveAsPackageVisible(false)}
                                    isModal={isModal}
                                    withPeak={withPeak}
                                    onSave={onSavePackage}
                                    isCancelActive={isCancelActive}
                                    isForPackages={true}
                                />
                            )}
                        </div>
                    ))}
            </div>
        </Fragment>
    );
};

export default PackageIcons;
